"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _get = _interopRequireDefault(require("lodash/get"));
var _isNumber = _interopRequireDefault(require("lodash/isNumber"));
var _webMediaPlayer = _interopRequireDefault(require("@tunein/web-media-player"));
var _Player2 = _interopRequireDefault(require("../models/Player"));
var _timeToPercentage = _interopRequireDefault(require("../utils/timeToPercentage"));
var _playerName = _interopRequireDefault(require("../constants/playerName"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var mediaErrorNames = ['MediaErrorAborted', 'MediaErrorNetwork', 'MediaErrorDecode', 'MediaErrorSourceNotSupported'];
function onError(callback, mediaElement) {
  return function (event) {
    var error = new Error("".concat(_playerName["default"].WebMediaPlayer, " error"));
    var mediaError = (0, _get["default"])(mediaElement, 'error') || {};
    var _ref = event || {},
      message = _ref.message,
      eventError = _ref.error,
      context = _ref.context;
    error.errorData = _objectSpread(_objectSpread({}, eventError), {}, {
      context: context,
      // TODO: these are being used as a fail-safe for the experiment, but they might not be
      //  needed after we confirm that the above data is sufficient
      isMediaError: mediaErrorNames.includes((0, _get["default"])(eventError, 'name')),
      eventMessage: message || (0, _get["default"])(error, 'message'),
      mediaErrorCode: mediaError.code,
      mediaErrorMessage: mediaError.message
    });
    return callback(error);
  };
}
var WebMediaPlayerManager = exports["default"] = /*#__PURE__*/function (_Player) {
  (0, _inherits2["default"])(WebMediaPlayerManager, _Player);
  function WebMediaPlayerManager() {
    var _this;
    var keepMediaElementAlive = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    (0, _classCallCheck2["default"])(this, WebMediaPlayerManager);
    _this = _callSuper(this, WebMediaPlayerManager, [_playerName["default"].WebMediaPlayer]);
    var mediaElement = document.createElement('audio');
    document.body.appendChild(mediaElement);
    mediaElement.setAttribute('style', 'width: 0px; height: 0px; display: none;');
    _this.player = new _webMediaPlayer["default"]({
      mediaElement: mediaElement,
      keepMediaElementAlive: keepMediaElementAlive,
      onlyUseCoreEngine: true,
      shoutcast: {
        disable: true
      }
    });
    return _this;
  }
  (0, _createClass2["default"])(WebMediaPlayerManager, [{
    key: "on",
    value: function on(event, callback) {
      this.player.on(event, callback);
    }
  }, {
    key: "off",
    value: function off(event, callback) {
      this.player.off(event, callback);
    }

    /**
     * This is necessary on Safari mobile and desktop browsers due to autoplay restrictions.
     * See PlayerLoader.js for more details.
     * @param blankMp3Url {string}
     */
  }, {
    key: "preload",
    value: (function () {
      var _preload = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(blankMp3Url) {
        var blankMp3AbsoluteUrl;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              blankMp3AbsoluteUrl = new URL(blankMp3Url, window.location.href).toString();
              _context.next = 4;
              return this.player.load(blankMp3AbsoluteUrl);
            case 4:
              if (!this.player.isLoaded()) {
                _context.next = 7;
                break;
              }
              _context.next = 7;
              return this.player.play();
            case 7:
              _context.next = 11;
              break;
            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](0);
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 9]]);
      }));
      function preload(_x) {
        return _preload.apply(this, arguments);
      }
      return preload;
    }())
  }, {
    key: "load",
    value: function load(url, format) {
      var _this2 = this;
      return new Promise( /*#__PURE__*/function () {
        var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(resolve, reject) {
          return _regenerator["default"].wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _this2.player.once('error', onError(reject, _this2.player.getMediaElement()));
                _context2.next = 4;
                return _this2.player.load({
                  url: url,
                  format: format
                });
              case 4:
                if (_this2.player.isLoaded()) {
                  resolve();
                }
                _context2.next = 10;
                break;
              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2["catch"](0);
                onError(reject, _this2.player.getMediaElement())(_context2.t0);
              case 10:
              case "end":
                return _context2.stop();
            }
          }, _callee2, null, [[0, 7]]);
        }));
        return function (_x2, _x3) {
          return _ref2.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "play",
    value: function () {
      var _play = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(playPosition) {
        var _this3 = this;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return new Promise(function (resolve, reject) {
                _this3.player.once('playing', resolve);
                _this3.player.once('error', onError(reject, _this3.player.getMediaElement()));
                if (Number.isFinite(+playPosition) && playPosition !== _this3.player.getCurrentTime()) {
                  _this3.player.once('canplay', function () {
                    _this3.player.seekTo(playPosition);
                  });
                }
                _this3.player.play();
              });
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      function play(_x4) {
        return _play.apply(this, arguments);
      }
      return play;
    }()
  }, {
    key: "seek",
    value: function seek(position) {
      this.player.seekTo(position / 100 * this.player.getDuration());
    }
  }, {
    key: "pause",
    value: function pause() {
      this.player.pause();
    }
  }, {
    key: "stop",
    value: function stop() {
      this.player.stop();
    }
  }, {
    key: "canChangePlaybackRate",
    value: function canChangePlaybackRate() {
      return !!this.player.getPlaybackRate();
    }
  }, {
    key: "getPlaybackRate",
    value: function getPlaybackRate() {
      return this.player.getPlaybackRate();
    }
  }, {
    key: "changePlaybackRate",
    value: function changePlaybackRate(rate) {
      this.player.setPlaybackRate(rate);
    }
  }, {
    key: "unload",
    value: function unload() {
      this.player.unload();
    }

    // WMP doesn't provide a dedicated destroy method, but its unload method unloads and destroys
  }, {
    key: "destroy",
    value: function destroy() {
      this.unload();
    }
  }, {
    key: "setVolume",
    value: function setVolume(volume) {
      if ((0, _isNumber["default"])(volume)) {
        this.player.setVolume(volume / 100);
      }
    }
  }, {
    key: "getVolume",
    value: function getVolume() {
      return this.player.getVolume() || 0;
    }
  }, {
    key: "toggleMute",
    value: function toggleMute() {
      this.player.toggleMute();
    }
  }, {
    key: "getTimes",
    value: function getTimes() {
      var duration = this.player.getDuration() || 0;
      var elapsedSeconds = this.player.getCurrentTime() || 0;
      return {
        duration: Math.floor(duration),
        elapsedSeconds: Math.floor(elapsedSeconds),
        elapsedPercent: (0, _timeToPercentage["default"])(elapsedSeconds, duration)
      };
    }
  }]);
  return WebMediaPlayerManager;
}(_Player2["default"]);
//# sourceMappingURL=WebMediaPlayer.js.map